/**
 * npm owns this bootstrap so an unpinned project-level pnpm cannot block before
 * BetterStart has a package.json where it can enforce the supported pnpm version.
 */
export function createNextAppCommand(): { bin: string; prefix: string[] } {
  return {
    bin: 'npm',
    prefix: ['exec', '--yes', '--package=create-next-app@latest', '--', 'create-next-app']
  }
}
